import { useContext } from 'react';

import SeasonalCard from '@/components/game/ui/card/SeasonalCard';
import SummitCard from '@/components/game/ui/card/SummitCard';
import ActionButton from '@/components/game/ui/corner/ActionButton';
import { GameContext, ViewContext } from '@/state/contexts';
import { performActionType } from '@/type/performAction';
import { cardPurchaseRequiresDecision } from '@/util/card';
import {
	buyBattery,
	buyFactory,
	buyPR,
	donateEnergy,
	playCard,
	playSummitCard,
} from '@lc/const/socketEvent';
import { createActionParams } from '@lc/interface/actionParams/factory';
import { createPayment } from '@lc/interface/payment/factory';
import '@/style/HandModal.css';
import { useTutorial } from '@/hooks/useTutorial';
import { logg } from '@/util/logg';
import { tutStep_17, tutStep_22, tutStep_23, tutStep_25, tutStep_26 } from '@/lyoc-common/src/const/tutorial';

const PaymentCluster = () => {
	const {
		// currPlayer,
		myState,
		selectedAction,
		setSelectedAction,
		selectedActionCost,
		setSelectedActionCost,
		selectedCard,
		selectedCardId, // TODO selectedCard will determine price, source and target, decisions. Replace w/ cardId

		setPaymentTotal,
		paymentTotal,
		setPaymentObject,
		paymentObject,

		performAction,

		// setFArr,
		// fArr,
		// setBArr,
		// bArr,

		isTutorial,
		stepTutorial,
		setStepTutorial,
	}: any = useContext(GameContext);

	const { paymentMode, setPaymentMode, setShowDecisionModal, setPPE, currentTickerTimer, setCurrentTickerIndex }: any =
		useContext(ViewContext);

	if (!paymentMode) return;

	const { tutorialCheck } = useTutorial();

	const performActionTyped = performAction as performActionType;

	function resetPaymentParams() {
		setPaymentMode(false);
		const emptyPayment = createPayment();
		setPaymentObject(emptyPayment);
		setPaymentTotal(0);
		setSelectedAction('');
		setSelectedActionCost(0);
	}

	function cancelPayment() {
		resetPaymentParams();
	}

	function tutoralIncrement(){
		resetPaymentParams();
		setStepTutorial((prev) => prev + 1);
		clearTimeout(currentTickerTimer);
		setCurrentTickerIndex((prev) => prev + 1);
	}

	function tutorialPurchase(){
		// BUY A BATTERY
		logg('tutorialP');
		switch(stepTutorial){
			case tutStep_17:
				if(paymentObject.factoryEnergyArr.length === 1){
					myState.batteries = 1;
					myState.factoryEnergyArr = ['y'];
					setPPE(1);
					tutoralIncrement();
				}
				break;
			case tutStep_23:
				if(paymentObject.batteryEnergyArr.length === 1){
					const prEnergy = myState.batteryEnergyArr.pop();
					myState.prArr.push(prEnergy);
					myState.seasonalCards = [];
					setPPE(0);
					tutoralIncrement();
				}
				break;
		}
	}

	function payForActionSend() {
		// TODO check if cardId if playCard has a decision, if so GOTO DecisionModal
		let makeDecision = false;

		if(isTutorial){
			tutorialPurchase();
			return;
		}

		if (selectedAction === playCard || selectedAction === playSummitCard) {
			// determine if card needs decision here
			makeDecision = cardPurchaseRequiresDecision(selectedCardId);

			const actionParams = createActionParams(
				selectedCardId,
				paymentObject
			);

			if (!makeDecision) {
				performActionTyped(selectedAction, actionParams);
			}
		} else if (
			selectedActionCost === paymentTotal ||
			selectedAction === donateEnergy
		) {
			const actionParams = createActionParams(-1, paymentObject);

			performActionTyped(selectedAction, actionParams);
		} else {
			alert('Incorrect payment');
		}

		if (makeDecision) {
			// requestClientDecision(); // close PaymentModal and goto DecisionModal
			setShowDecisionModal(true);
			return;
		}

		resetPaymentParams();
	}

	function selectedActionInEnglishMFr() {
		switch (selectedAction) {
			case buyBattery:
				return 'Buy Battery';
			case buyFactory:
				return 'Buy Factory';
			case buyPR:
				return 'Buy PR';
			case playCard:
				return 'Play Card';
			case playSummitCard:
				return 'Play Summit Card';
			default:
				return selectedAction;
		}
	}

	return (
		<div className="butt-right-enable">
			{selectedAction === playCard && (
				<div className="centered">
					<div className="card">
						<SeasonalCard
							cardId={selectedCardId}
							width={0}
							height={0}
						/>
					</div>
				</div>
			)}
			{selectedAction === playSummitCard && (
				<div className="centered">
					<div className="card">
						<SummitCard
							cardId={selectedCardId}
							width={0}
							height={0}
						/>
					</div>
				</div>
			)}
			<ActionButton
				leftEmoji="✅ Pay "
				/* leftText="Pay" */
				onClickFunc={() => {
					payForActionSend();
				}}
			/>
			{selectedActionInEnglishMFr()}

			{selectedAction === donateEnergy ? (
				<div>Selected: {paymentTotal}</div>
			) : (
				<div>
					Cost: {selectedActionCost} Selected: {paymentTotal}
				</div>
			)}

			<ActionButton
				leftEmoji="❌ Cancel"
				/* leftText="Cancel" */
				onClickFunc={() => {
					cancelPayment();
				}}
			/>
		</div>
	);
};

export default PaymentCluster;
